import {
  ChefHat,
  Clock,
  Cloud,
  CreditCard,
  MonitorSmartphone,
  MoreHorizontal,
  Receipt,
  ScrollText,
  ShoppingBag,
  User,
} from "lucide-react";
import type { ComponentType } from "react";

export type POSPrimaryNavItem = {
  key: string;
  label: string;
  mobileLabel: string;
  icon: ComponentType<{ className?: string }>;
  isActive: (pathname: string) => boolean;
  navigate: () => {
    to: string;
    search?: Record<string, unknown>;
  };
};

export type POSMoreNavItem = {
  key: string;
  label: string;
  description: string;
  icon: ComponentType<{ className?: string }>;
  isActive?: (pathname: string) => boolean;
  navigate?: () => {
    to: string;
    search?: Record<string, unknown>;
  };
  externalHref?: string;
};

export const POS_PRIMARY_NAV: POSPrimaryNavItem[] = [
  {
    key: "pos",
    label: "POS",
    mobileLabel: "ຂາຍ",
    icon: ShoppingBag,
    isActive: (pathname) => pathname === "/app/pos",
    navigate: () => ({ to: "/app/pos" }),
  },
  {
    key: "orders",
    label: "ລາຍການ Order",
    mobileLabel: "Order",
    icon: ScrollText,
    isActive: (pathname) => pathname.startsWith("/app/pos/orders"),
    navigate: () => ({
      to: "/app/pos/orders",
      search: { page: 1, sortField: "createdAt", sortOrder: "desc" },
    }),
  },
  {
    key: "kitchen",
    label: "ຄິວຄົວ (KDS)",
    mobileLabel: "ຄົວ",
    icon: ChefHat,
    isActive: (pathname) => pathname.startsWith("/app/pos/kitchen"),
    navigate: () => ({ to: "/app/pos/kitchen" }),
  },
  {
    key: "shifts",
    label: "ລາຍການກະ",
    mobileLabel: "ກະ",
    icon: Clock,
    isActive: (pathname) => pathname.startsWith("/app/pos/shifts"),
    navigate: () => ({ to: "/app/pos/shifts" }),
  },
];

export const POS_MORE_NAV: POSMoreNavItem[] = [
  {
    key: "payment-methods-report",
    label: "ລາຍງານການຊຳລະ",
    description: "ຕາມວິທີຊຳລະເງິນ",
    icon: CreditCard,
    isActive: (pathname) =>
      pathname === "/app/pos/reports/payment-methods",
    navigate: () => ({ to: "/app/pos/reports/payment-methods" }),
  },
  {
    key: "bill-settings",
    label: "ຕັ້ງຄ່າບິນ",
    description: "ໂລໂກ້, ຂໍ້ຄວາມທ້າຍບິນ",
    icon: Receipt,
    isActive: (pathname) => pathname === "/app/pos/settings/bill",
    navigate: () => ({ to: "/app/pos/settings/bill" }),
  },
  {
    key: "customer-display-settings",
    label: "ຕັ້ງຄ່າຫນ້າຈໍ",
    description: "Customer display",
    icon: MonitorSmartphone,
    isActive: (pathname) =>
      pathname === "/app/pos/settings/customer-display",
    navigate: () => ({ to: "/app/pos/settings/customer-display" }),
  },
  {
    key: "sync-debug",
    label: "Offline sync",
    description: "Debug & queue",
    icon: Cloud,
    isActive: (pathname) => pathname === "/app/pos/settings/sync",
    navigate: () => ({ to: "/app/pos/settings/sync" }),
  },
  {
    key: "customer-display",
    label: "ຫນ້າຈໍລູກຄ້າ",
    description: "ເປີດໃນ tab ໃໝ່",
    icon: MonitorSmartphone,
    externalHref: "/app/pos/customer-display",
  },
  {
    key: "profile",
    label: "ໂປຣໄຟລ໌",
    description: "ບັນຊີຜູ້ໃຊ້",
    icon: User,
    isActive: (pathname) => pathname.startsWith("/app/profile"),
    navigate: () => ({ to: "/app/profile" }),
  },
];

export function isPOSMoreMenuActive(pathname: string): boolean {
  return (
    pathname.startsWith("/app/pos/reports") ||
    pathname.startsWith("/app/pos/settings") ||
    pathname.startsWith("/app/profile")
  );
}

export const POS_MORE_MENU_ICON = MoreHorizontal;
